import axios from 'axios';

import routes from 'app/routes';

export default {
  create: (memberId, values, successCallback, errorCallback) => {
    const formData = new FormData();

    Object.keys(values).forEach((key) => {
      formData.append(key, values[key] === null ? '' : values[key]);
    });

    formData.append('member_id', memberId);

    axios
      .post(routes.api.managers.assessments.create, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((resp) => {
        successCallback(resp.data.data);
      }).catch((error) => {
        errorCallback(error.response.data);
      });
  },
  delete: (memberId, assessmentId, successCallback) => {
    axios
      .delete(routes.api.managers.assessments.delete(assessmentId), {
        params: {
          member_id: memberId,
        },
      })
      .then(() => {
        successCallback();
      });
  },
};
